import { AxiosInstance, AxiosRequestConfig } from 'axios'

import endpoints, { Endpoint } from '../../constants/endpoints'

interface SigningApiInterface {
  requestContractSmsCode: (obj?: any) => Promise<any>
  requestScoringSmsCode: (obj?: any) => Promise<any>
  requestPreContractSmsCode: (obj?: any) => Promise<any>
  verifyContractSmsCode: (obj?: any) => Promise<any>
  verifyScoringSmsCode: (obj?: any) => Promise<any>
  verifyPreContractSmsCode: (obj?: any) => Promise<any>
}

export interface OpenApiInterface extends SigningApiInterface {
  commitLoanConfiguratorRescoring: (obj?: any) => Promise<any>
  createCif: (obj?: any) => Promise<any>
  dataLock: (obj?: any) => Promise<any>
  finishOnline: (obj?: any) => Promise<any>
  postMobileIdResend: () => Promise<any>
  getAddressHints: (obj?: any) => Promise<any>
  getAvailability: () => Promise<any>
  getCifStatus: (obj?: any) => Promise<any>
  getClientScoringStatus: (obj?: any) => Promise<any>
  getCodetableCountries: () => Promise<any>
  getCodetableEducation: () => Promise<any>
  getCodetableEmploymentTypes: () => Promise<any>
  getCodetableHousingTypes: () => Promise<any>
  getCodetableMaritalStatuses: () => Promise<any>
  getContract: (obj?: any) => Promise<any>
  getContractSignStatus: (obj?: any) => Promise<any>
  getEmployerHints: (obj?: any) => Promise<any>
  getListOfRequirements: () => Promise<any>
  getLoanRanges: (obj?: any) => Promise<any>
  getNeededDocs: (obj?: any) => Promise<any>
  getOccupations: (obj?: any) => Promise<any>
  getPennyPayment: (obj?: any) => Promise<any>
  getPopPostProcessingStatus: (obj?: any) => Promise<any>
  getPreContract: (obj?: any) => Promise<any>
  getPreContractStatus: (obj?: any) => Promise<any>
  getSaveReturnUrl: (obj?: any) => Promise<any>
  getUploadPopStart: () => Promise<any>
  hello: () => Promise<any>
  postMobileIdStart: () => Promise<any>
  getMobileIdStatus: () => Promise<any>
  initClientCache: (obj?: any) => Promise<any>
  initLoanConfigurator: (obj?: any) => Promise<any>
  pennyPaymentConfirm: (obj?: any) => Promise<any>
  postPopProcessingSetup: () => Promise<any>
  getPopProcessingStatus: () => Promise<any>
  requestCacheSmsCode: (obj?: any) => Promise<any>
  saveAccountNumber: (obj?: any) => Promise<any>
  saveClientAdditionalInfo: () => Promise<any>
  saveClientAddresses: () => Promise<any>
  saveClientDetails: () => Promise<any>
  saveClientInfo: () => Promise<any>
  postPreContractGenerate: () => Promise<any>
  saveFinanceEmployer: () => Promise<any>
  saveFinanceExpenses: () => Promise<any>
  saveFinanceIncome: () => Promise<any>
  saveFinanceProfession: () => Promise<any>
  saveLoanPreConfigurator: (obj?: any) => Promise<any>
  setupFinishOnBranch: (obj?: any) => Promise<any>
  startClientScoring: (obj?: any) => Promise<any>
  testCacheExists: (obj?: any) => Promise<any>
  trackFinishInIb: (obj?: any) => Promise<any>
  trackFinishOnBranch: (obj?: any) => Promise<any>
  trackFinishToBusinessLoan: (obj?: any) => Promise<any>
  updateLoanConfigurator: (obj?: any) => Promise<any>
  postUploadPopFile: (obj?: any) => Promise<any>
  verifyCacheSmsCode: (obj?: any) => Promise<any>
}

interface CustomAxiosInstance extends AxiosInstance {
  [key: string]: any
}

export default (api: CustomAxiosInstance, securedConfig: AxiosRequestConfig): OpenApiInterface => {
  const preparedEndpoints: any = {}
  const openApiEndpoints = endpoints.openApi

  const keys = Object.keys(openApiEndpoints)

  keys.forEach((key: string) => {
    const endpoint: Endpoint = openApiEndpoints[key]
    const method: string = endpoint.method
    const url: string = `${endpoint.secured ? '/secured' : '/unsecured'}${endpoint.url}`

    preparedEndpoints[key] = (data?: any) =>
      api[method](
        url,
        data || (method === 'post' ? {} : undefined), // post must have at least empty object
        endpoint.secured ? securedConfig : undefined
      )
  })

  return preparedEndpoints as OpenApiInterface
}
